import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/index'

//Store
import store from './store/index'

// Override Vuetify text-h6 font-family after Vuetify loads
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    .v-application .text-h6 {
      font-family: inherit !important;
    }
    #app .v-application .text-h6 {
      font-family: inherit !important;
    }
  `;
  document.head.appendChild(style);
}

// VueThailandAddress
import 'vue-thailand-address/dist/vue-thailand-address.css';
import VueThailandAddress from 'vue-thailand-address';
Vue.use(VueThailandAddress);

// Vue color picker
import InputColorPicker from "vue-native-color-picker";
Vue.use(InputColorPicker);

//Google Map
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.config.productionTip = false

// Register custom wrapper used across Arin pages.
// Vuetify does not provide <v-form-group>, but the codebase uses it as a layout wrapper.
// This prevents: [Vue warn]: Unknown custom element: <v-form-group>
Vue.component('v-form-group', {
  name: 'VFormGroup',
  functional: true,
  render(h, ctx) {
    const data = ctx.data || {}
    data.class = ['v-form-group', data.class]
    return h('div', data, ctx.children)
  },
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA1wttZIvDoikUR1HSUoZJYuhwd-TiWQYw',
    libraries: 'places',
  }
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
